<template>
  <vs-card>
    <ValidationObserver ref="refundReportFilterForm" v-slot="{ invalid }">
      <vs-row>
        <vs-col class="flex flex-col lg:w-1/3 w-full mb-4">
          <ValidationProvider
            name="Tipo de data"
            rules="required"
            v-slot="{ errors }"
          >
            <label for="Tipo de data">Tipo de data</label>
            <v-select
              v-model="filters.dateType"
              class="w-full"
              :options="dateTypeOptions"
              id="date-type"
              name="Tipo de data"
              label="label"
              placeholder="Selecione"
              data-testid="refund-report-date-type"
              :reduce="(option) => option.value"
              :class="!!errors.length ? 'has-error' : ''"
            ></v-select>
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="refund-report-date-type-selection-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/3 w-full mb-4">
          <label for="Data Inicial">Data Inicial</label>
          <ValidationProvider
            name="Data Inicial"
            rules="required|validDate|isTodayLessOrSameThan"
            v-slot="{ errors }"
          >
            <DatePicker
              id="start-date"
              name="Data Inicial"
              class="w-full"
              v-model="filters.startDate"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              value-type="format"
              :editable="true"
              :lang="lang"
              v-mask="'##/##/####'"
              :input-class="['mx-input', !!errors.length ? 'has-error' : '']"
              data-testId="refund-report-start-date-picker"
            />

            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="refund-report-start-date-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
        <vs-col class="flex flex-col lg:w-1/3 w-full mb-4">
          <label for="Data Final">Data Final</label>
          <ValidationProvider
            name="Data Final"
            :rules="`required|validDate|isTodayLessOrSameThan|isEndDateSameOrAfter:${filters.startDate},${maxDaysRange}|daysRange:${filters.startDate},${maxDaysRange}`"
            v-slot="{ errors }"
          >
            <DatePicker
              id="end-date"
              name="Data Final"
              class="w-full"
              v-model="filters.endDate"
              format="DD/MM/YYYY"
              placeholder="DD/MM/YYYY"
              value-type="format"
              :editable="true"
              :lang="lang"
              v-mask="'##/##/####'"
              :input-class="['mx-input', !!errors.length ? 'has-error' : '']"
              data-testId="refund-report-end-date-picker"
            />
            <span
              v-show="!!errors.length"
              class="text-danger"
              data-testId="refund-report-end-date-error"
            >
              {{ errors[0] }}
            </span>
          </ValidationProvider>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col v-if="showConvenants" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Convênio</label>
          <v-select
            clearable
            multiple
            v-model="filters.covenants"
            class="w-full"
            :options="covenants"
            id="convenant"
            label="label"
            data-testid="refund-report-convenant-select"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showConsultancies" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Assessoria</label>
          <v-select
            clearable
            multiple
            v-model="filters.consultancies"
            class="w-full"
            :options="consultancies"
            id="consultancy"
            label="label"
            data-testid="refund-report-consultancy-select"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
        <vs-col v-if="showBrokers" class="lg:w-1/3 w-full mb-4">
          <label class="labelFiltro">Corretora</label>
          <v-select
            clearable
            multiple
            v-model="filters.brokers"
            class="w-full"
            :options="brokers"
            id="broker"
            label="label"
            data-testid="refund-report-broker-select"
            :reduce="(option) => option.id"
          ></v-select>
        </vs-col>
      </vs-row>
      <vs-row vs-align="flex-end" vs-justify="flex-end" vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="flex justify-end mt-4">
            <vs-button
              color="#038803"
              type="filled"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              vs-w="2"
              class="pt-4 pb-4 mb-4 mt-2 mr-3 sm:mt-0"
              native-type="submit"
              data-testid="refund-report-send-button"
              :disabled="invalid"
              @click="send"
              >Gerar Relatório
            </vs-button>
          </div>
        </vs-col>
      </vs-row>
    </ValidationObserver>
  </vs-card>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DatePicker from 'vue2-datepicker';
import ptBr from 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';

import { REFUND_REPORT_DATE_TYPES } from '../constant/constant';
import reportsApi from '../../../../../services/reports.api';
import moment from 'moment';
import functions from '../../../../../utils/functions';

export default {
  name: 'RefundsReportFilter',
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePicker,
    vSelect,
  },
  data() {
    const { brokerId, consultancyId, convanantId } =
      functions.getDecoded(localStorage);
    return {
      brokerId,
      consultancyId,
      convanantId,
      lang: ptBr,
      maxDaysRange: 31,
      dateTypeOptions: REFUND_REPORT_DATE_TYPES,
      brokers: [],
      consultancies: [],
      covenants: [],
      filters: {
        dateType: null,
        startDate: null,
        endDate: null,
        brokers: [],
        consultancies: [],
        covenants: [],
      },
    };
  },
  computed: {
    isFullReadingPermission() {
      return this.$can('Leitura Carteira Completa', 'Restituições');
    },
    showBrokers() {
      return (
        this.isFullReadingPermission || this.consultancyId || this.convanantId
      );
    },
    showConsultancies() {
      return this.isFullReadingPermission || this.convanantId;
    },
    showConvenants() {
      return this.isFullReadingPermission;
    },
  },
  mounted() {
    this.getContext();
  },
  methods: {
    async getContext() {
      const callGetFullContext = () => reportsApi.getFullContext();
      const callGetUserContext = () => reportsApi.getUserContext();
      const data = this.isFullReadingPermission
        ? await callGetFullContext()
        : await callGetUserContext();
      this.brokers = data.brokers;
      this.consultancies = data.consultancies;
      this.covenants = data.covenants;
    },
    async send() {
      const valid = await this.$refs.refundReportFilterForm.validate();
      if (!valid) {
        return;
      }
      const start = moment(this.filters.startDate, 'DD/MM/YYYY').toDate();
      const end = moment(this.filters.endDate, 'DD/MM/YYYY').toDate();
      const startDate = start.toISOString().split('T')[0] + 'T00:00:00';
      const endDate = end.toISOString().split('T')[0] + 'T23:59:59';
      this.$emit('export', {
        ...this.filters,
        startDate,
        endDate,
      });
    },
  },
};
</script>
